import { atom } from 'jotai'
import { SupportedTicker } from '@/constants/token'
import { ETHEREUM_CHAIN_ID } from '@/constants'

export const TickerAtom = atom<SupportedTicker>('MUBI')
export const TargetChainAtom = atom<number>(ETHEREUM_CHAIN_ID)
